export default __webpack_public_path__ + "static/media/photo--lg--106.f8f28d29.jpg";